import React from "react";

//Custom Components
import PrijevozniciPage from "UI/AppPage/PrijevozniciPage";
import ResponsiveBox from "UI/Box/ResponsiveBox";
import PrijevozniciPosebnePonudeTable from "Views/Prijevoznici/PosebnePonude/PrijevozniciPosebnePonudeTable";

const PrijevozniciPosebnePonudePage = React.memo((props) => {
  return (
    <PrijevozniciPage>
      <ResponsiveBox fillHeight>
        <PrijevozniciPosebnePonudeTable />
      </ResponsiveBox>
    </PrijevozniciPage>
  );
});

export default PrijevozniciPosebnePonudePage;
